<template>
  <div v-click-outside="closeCartByClickOutside" :class="['header-cart', cssClasses]">
    <button
      v-element-loader="{ endpoint: 'getCart', useSmallLoader: true }"
      class="button button--ghost button--icon-left header-cart__button"
      :class="{ 'button-link--active': isCartOpen }"
      data-pw="header-cart"
      @click="toggleHeaderButton()">
      <oie-use-svg svg="cart" css-classes="header-cart__icon"></oie-use-svg>
      <div class="header-cart__text">
        {{ tStatic('headerCartHeader') }}
      </div>
      ({{ count }})
    </button>

    <oie-header-cart-notification v-if="!isCartDocked"></oie-header-cart-notification>
    <div
      v-show="isCartOpen"
      ref="cartResult"
      class="cart-result"
      :style="maxHeightCartResult"
      :class="{ 'cart-result--is-docked': isCartDocked }">
      <div ref="header" class="cart-result__actions">
        <div v-if="showSuperUserCart">
          <div class="cart-shell-container__superuser-header">
            <!-- Super user cart -->
            <oie-base-dropdown
              v-model="currentCart"
              :options="createSuperUserCurrentCartOptions"
              :default-selected="createDefaultCurrentCart"
              :label-text="tStatic('superUserCartActiveCart')"
              class="cart-shell-container__dropdown"
              @input="handleCartChange">
            </oie-base-dropdown>
            <oie-superuser-cart-actions-slide-in class="header-navigation__global-superuser-selector"></oie-superuser-cart-actions-slide-in>
          </div>
        </div>
        <div v-if="!showSuperUserCart" class="cart-result__header">
          {{ tStatic('headerCartHeader') }}
        </div>
        <button v-show="dockingAvaliable" class="cart-result__dock" @click="toggleValue({key: 'isCartDocked'})">
          <span v-if="!isCartDocked"> {{ tStatic('headerCartPin') }}</span>
          <span v-else>{{ tStatic('headerCartUnpin') }}</span>
          <span class="cart-result__dock-button" :class="{ 'cart-result__dock-button--is-docked': isCartDocked }"></span>
        </button>

        <button v-if="mq('to-medium')" class="cart-result__close-cart" @click="toggleValue({key: 'isCartOpen'})">
          <oie-use-svg svg="close" color="#006DB6"></oie-use-svg>
        </button>
      </div>

      <div ref="products" v-scroll-lock="mq('to-medium') && isCartOpen && !isCartDocked" class="cart-result__article-search-cart-products-container">
        <div
          ref="article_search"
          v-element-loader="{ endpoint: ['cart/addToCart'] }"
          :class="['cart-result__article-actions-container', { 'cart-result__article-actions-container--compact-mode': !dockingAvaliable && mq('medium') }]">
          <oie-base-input
            id="header-article"
            ref="article"
            v-model="quickAddNumber"
            :placeholder="tStatic('headerCartQuickAddPlaceholder')"
            class="cart-result__search"
            data-pw="header-article-input"
            @keyup.enter.native="quickAdd">
          </oie-base-input>
          <oie-base-input
            id="header-quantity"
            v-model="quickAddQuantity"
            class="cart-result__search-amount"
            data-pw="header-quantity-input"
            @keyup.enter.native="quickAdd">
            <template v-slot:iconAppend>
              <button class="cart-result__search-action" data-pw="cart-quick-add" @click="quickAdd">
                <oie-use-svg svg="close" class="svg--45 cart-result__search-svg"></oie-use-svg>
              </button>
            </template>
          </oie-base-input>
        </div>

        <div v-if="cart.rows !== undefined && cart.rows.length === 0" class="cart-empty-state">
          <div class="cart-empty-state__header">
            {{ tStatic('headerCartEmptyHeader') }}
          </div>

          <p class="cart-empty-state__text">
            {{ tStatic('headerCartEmptyText') }}
          </p>
        </div>

        <div v-else class="cart-products">
          <div ref="cart_items" class="cart-products__items">
            <oie-campaign-chip v-for="(campaign, i) in cart.campaigns" :key="`campaign_${i}`" :config="campaign"></oie-campaign-chip>
            <oie-cart-product-item
              v-for="(cartRow, i) of cart.rows"
              :key="`${cartRow.id}_${cart.name}`"
              :cart-row="cartRow"
              :cart-name="cart.name"
              :data-pw="`cart-row-${i}`"></oie-cart-product-item>
          </div>
        </div>

        <div class="cart-result__summary-action">
          <div ref="summary" class="cart-result__summary">
            <oie-message-box v-if="cart.rows !== undefined && cart.rows.length > 0">
              <div class="cart-result__summary-item">
                {{ tStatic('headerCartItemsVatLabel') }}

                <div class="cart-result__summary-item-value">
                  {{ formatPrice(cart.tax) }}
                </div>
              </div>

              <div class="cart-result__summary-item cart-result__summary-item--total">
                <div class="cart-result__summary-item-double-row">
                  {{ tStatic('headerCartItemsCostLabel') }}

                  <span class="cart-result__summary-item-what-vat">
                    {{ useVat ? tStatic('priceIncludingVat') : tStatic('priceExcludingVat') }}
                  </span>
                </div>

                <div class="cart-result__summary-item-value cart-result__summary-item-value--total">
                  {{ formatPrice(cart.totalPrice) }}
                </div>
              </div>
            </oie-message-box>
          </div>

          <oie-base-button
            v-if="cart.rows !== undefined && cart.rows.length > 0"
            is-type="a"
            :href="clientModel.cartPageUrl"
            css-classes="button--with-border button--green cart-result__to-cart-url"
            :text="tStatic('cartGotoCheckout')"
            @click="closeCart"></oie-base-button>
        </div>
      </div>

      <div class="cart-result__summary-action">
        <div ref="summary" class="cart-result__summary">
          <oie-message-box v-if="cart.rows !== undefined && cart.rows.length > 0">
            <div class="cart-result__summary-item">
              {{ tStatic('headerCartItemsVatLabel') }}

              <div class="cart-result__summary-item-value">
                {{ formatPrice(cart.tax) }}
              </div>
            </div>

            <div class="cart-result__summary-item cart-result__summary-item--total">
              <div class="cart-result__summary-item-double-row">
                {{ tStatic('headerCartItemsCostLabel') }}

                <span class="cart-result__summary-item-what-vat">
                  {{ useVat ? tStatic('priceIncludingVat') : tStatic('priceExcludingVat') }}
                </span>
              </div>

              <div class="cart-result__summary-item-value cart-result__summary-item-value--total">
                {{ formatPrice(cart.totalPrice) }}
              </div>
            </div>
          </oie-message-box>
        </div>

        <oie-base-button
          v-if="cart.rows !== undefined && cart.rows.length > 0"
          is-type="a"
          :href="clientModel.cartPageUrl"
          css-classes="button--with-border button--green cart-result__to-cart-url"
          :text="tStatic('cartGotoCheckout')"
          data-pw="go-to-cart-page"
          @click="closeCart"></oie-base-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import gtm from '@/core/enhanced-ecommerce-gtm'
import previousMarket from '@/mixins/previous-market'
import EventBus from '@/core/event-bus'
import { listTypes } from '@/core/analytics-variables'
import httpService from '@/core/http-service'

export default {
  mixins: [previousMarket],
  data: () => ({
    quickAddNumber: '',
    quickAddQuantity: '1',
    dockingAvaliable: true,
    maxHeightOffset: 7.6,
    currentCart: null
  }),
  computed: {
    ...mapGetters('ui', ['isCartOpen', 'isCartDocked', 'useVat', 'isNavigationOpen', 'isSearchOpen']),
    ...mapGetters('commerce', ['cart']),
    ...mapGetters(['enableGtm']),
    count() {
      return _.chain(this.cart.rows).map(row => row.quantity).sum().value()
    },
    totalPrice() {
      return this.cart.totalPrice + this.cart.shippingFee
    },
    maxHeightCartResult() {
      return { 'maxHeight': `calc(100vh - ${this.maxHeightOffset}rem)` }
    },
    activeCart() {
      return this.cart
    },
    createSuperUserCurrentCartOptions() {
      return [{ text: this.tStatic('superUserCartTypeCustomer'), value: 'customer' }, { text: this.tStatic('superUserCartTypeSuperUser'), value: 'superuser' }]
    },
    createDefaultCurrentCart() {
      return this.activeCart.isSuperUserCart ? this.tStatic('superUserCartTypeSuperUser') : this.tStatic('superUserCartTypeCustomer')
    },
    showSuperUserCart() {
      return this.clientModel.impersonating !== null && !this.clientModel.impersonating.anonymous
    }
  },
  watch: {
    cart: {
      deep: true,
      handler(newCart) {
        this.currentCart = newCart.isSuperUserCart ? 'superuser' : 'customer'
      }
    }
  },
  mounted() {
    EventBus.$on('dismiss-message', this.setMaxHeightOffset)

    this.dockingAvaliable = this.mq('min-width-docking')

    this.$nextTick(function() {
      window.addEventListener('resize', _.throttle(this.windowWidth, 600))
      this.$refs.products.addEventListener('scroll', _.throttle(this.scrollShadow, 100))
      this.$refs.cartResult.addEventListener('scroll', _.throttle(this.landscapeScrollShadow, 100))
      this.setMaxHeightOffset()
    })

    if (this.previousMarket === null) {
      this.setPreviousMarketToCurrent()
    }

    if (!this.isPreviousMarketSameAsCurrent) {
      this.setPreviousMarketToCurrent(true)
    }
  },
  beforeDestroy () {
    EventBus.$off('dismiss-message')
  },
  methods: {
    ...mapActions('ui', ['toggleValue']),
    ...mapActions('commerce', ['addToCart', 'getCart']),
    setMaxHeightOffset() {
      this.maxHeightOffset = 7.6
      if (this.mq('medium')) {
        let banners = document.querySelectorAll('.js-banner')
        this.maxHeightOffset += Array.from(banners).reduce((acc, banner) => acc + Math.ceil(banner.clientHeight / 16), 0)
      }
    },
    async handleCartChange(newCartValue) {
      if ((!this.activeCart.isSuperUserCart && newCartValue === 'superuser') || (this.activeCart.isSuperUserCart && newCartValue === 'customer')) {
        await httpService.post(`superuser/cart/changeCurrentCart`, { changeToSuperUserCart: this.currentCart === 'superuser' })
          .then(() => {
            this.getCart(this.clientModel.cartType)
          })
      }
    },
    toggleHeaderButton() {
      if (this.mq('to-medium')) {
        window.location = this.clientModel.cartPageUrl
      } else {
        if(this.isCartDocked) {
          this.toggleValue({ key: 'isCartDocked' })
        }

        if (this.isNavigationOpen) {
          this.toggleValue({ key: 'isNavigationOpen', data: false })
        }

        this.toggleValue({ key: 'isSearchOpen', data: false })

        if (!this.isSearchOpen) {
          const headerSearch = document.querySelector('.header-bottom__search')

          headerSearch.addEventListener('transitionend', () => {
            headerSearch.classList.remove('header-bottom__search--remove-overflow')
          })
        }

        this.toggleValue({ key: 'isCartOpen' })
        this.$nextTick(function() {
          this.initialShadow()
        })
      }
    },
    closeCartByClickOutside() {
      if (!this.isCartDocked) {
        this.toggleValue({ key: 'isCartOpen', data: false })
      }
    },
    async quickAdd() {
      if (this.quickAddNumber) {
        // Normalize
        if (typeof this.quickAddQuantity === 'string') {
          this.quickAddQuantity = this.quickAddQuantity.replace(',', '.')
        }

        const parsedValue = Math.round(parseFloat(this.quickAddQuantity))

        if (!isNaN(parsedValue)) {
          this.quickAddQuantity = parsedValue
        } else {
          this.quickAddQuantity = 0
        }

        this.addToCart({ itemId: this.quickAddNumber, purchasedOnCategory: null, quantity: this.quickAddQuantity }).then((data) => {
          if (this.enableGtm && data.cart && data.cart.lineItemsAdded) {
            const addedProduct = data.cart.rows.find(x => x.itemId.toLowerCase() === this.quickAddNumber.toLowerCase())

            if (addedProduct) {
              const gtmObject = gtm.createGtmItem(
                addedProduct.itemId,
                addedProduct.displayName,
                addedProduct.item ? addedProduct.item.purchasedToVehicle : '',
                addedProduct.item ? addedProduct.item.purchasedOnCategory : '',
                this.formatPriceWithoutCurrency(addedProduct.priceExVat),
                this.quickAddQuantity,
                listTypes.CART) // list type

              gtm.addToCart(gtmObject)
            }
          }

          this.quickAddNumber = ''
          this.quickAddQuantity = '1'

          setTimeout(() => {
            const cartItem = this.$refs.cart_items.childNodes[0]
            cartItem.classList.add('cart-product--new')

            setTimeout(() => {
              cartItem.classList.remove('cart-product--new')
            }, 2000)
          }, 100)
        })
        await this.$nextTick()
        this.$refs.article.$el.children[0].children[0].focus()
      }
    },
    windowWidth() {
      this.dockingAvaliable = this.mq('min-width-docking')

      if (!this.dockingAvaliable && this.isCartOpen && this.isCartDocked) {
        this.toggleValue({ key: 'isCartDocked' })
      }
    },
    closeCart() {
      this.toggleValue({ key: 'isCartOpen', data: false })
    },
    scrollShadow() {
      const currentPosition = this.$refs.products.scrollTop
      const productsHeight = this.$refs.products.offsetHeight
      const bottomPosition = this.$refs.products.scrollHeight

      if (currentPosition === 0) {
        if (this.mq('to-medium')) {
          this.$refs.header.classList.remove('cart-result__actions--shadow')
        } else {
          this.$refs.article_search.classList.remove('cart-result__article-actions-container--shadow')
        }
      }

      if (currentPosition > 0) {
        if (this.mq('to-medium')) {
          this.$refs.header.classList.add('cart-result__actions--shadow')
        } else {
          this.$refs.article_search.classList.add('cart-result__article-actions-container--shadow')
        }
      }

      if (currentPosition + productsHeight < bottomPosition) {
        this.$refs.summary.classList.add('cart-result__summary--shadow')
      }

      if (currentPosition + productsHeight === bottomPosition) {
        this.$refs.summary.classList.remove('cart-result__summary--shadow')
      }
    },
    landscapeScrollShadow() {
      if (this.mq('landscape')) {
        const currentPosition = this.$refs.cartResult.scrollTop
        this.$refs.summary.classList.remove('cart-result__summary--shadow')

        if (currentPosition === 0) {
          this.$refs.header.classList.remove('cart-result__actions--shadow')
        }

        if (currentPosition > 0) {
          this.$refs.header.classList.add('cart-result__actions--shadow')
        }
      }
    },
    initialShadow() {
      const products = this.$refs.products

      if (products.scrollHeight > products.offsetHeight) {
        this.$refs.summary.classList.add('cart-result__summary--shadow')
      }
    }
  }
}
</script>

<style lang="scss">
.header-cart {
  position: relative;
}

.header-cart__button {
  width: 4.5rem;
  height: 2.125rem;

  @include media(small) {
    height: 2.5rem;
  }

  @include media(large) {
    width: 9.375rem;
  }
}

.header-cart__icon {
  width: 1.1875rem;
  height: 0.9375rem;
}

.header-cart__text {
  display: none;
  margin-right: measure(eighth);

  @include media(large) {
    display: block;
  }
}

/* eslint-disable-next-line vue-scoped-css/no-unused-selector */
.cart-result {
  display: flex;
  flex-direction: column;
  background-color: color(background-white);
  box-shadow: -3px 7px 16px 0 rgba(93, 92, 92, .5);
  color: color(text);
  z-index: 13;

  @include media(to-medium) {
    position: fixed;
    top: 4rem;
    top: 0;
    right: 0;
    left: 0;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    max-height: 100vh;
    max-height: -webkit-fill-available;
  }

  @include media([to-medium, landscape]) {
    overflow-y: auto;
    overflow-x: hidden;
  }

  @include media(medium) {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: measure(quarter);
    width: other(cart-width);
  }
}

.cart-result--is-docked {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: -0.6rem;
  bottom: 0;
  height: auto;
  margin-left: measure(quarter);

  @include media(medium) {
    max-height: 100vh;
  }
}

.cart-result > * {
  flex-shrink: 0;
}

.cart-result__actions {
  display: flex;
  align-items: center;
  padding: measure(quarter);
  background-color: color(background-white);
  z-index: 3;
}

.cart-result__actions--shadow {
  position: relative;
  z-index: 3;

  @include media(['to-medium', 'landscape']) {
    position: sticky;
    top: 0;
  }

  @include media(to-medium) {
    &::after {
      content: '';
      position: absolute;
      bottom: -1rem;
      right: -#{measure(quarter)};
      left: -#{measure(quarter)};
      height: 1rem;
      background-image: linear-gradient(to bottom, rgba(117, 117, 117, 0.2) 5%, rgba(265, 265, 265, 0));
    }
  }
}

.cart-result__header {
  @include h2-semi-bold;
  color: color(text-brand-blue);
}

.cart-result__dock {
  @include body-smaller;
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: 0;
  border: none;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }
}

.cart-result__dock-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.625rem;
  height: 2.375rem;
  background-color: color(background-gray-2);
  margin-left: measure(quarter);
  border-radius: 0 other(border-radius) other(border-radius) 0;

  &:after {
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='23' viewBox='0 0 16 23' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.66 11.894L.88 3 2.9.78l12.22 11.114L2.908 23 .89 20.78z' fill='%23FFFFFF' fill-rule='nonzero'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    width: 0.4375rem;
    height: 0.75rem;
  }
}

.cart-result__dock-button--is-docked {
  transform: rotate(180deg);
}

.cart-result__close-cart {
  background-color: transparent;
  border: none;
  margin: 0 0 0 auto;
  color: color(text-brand-blue);
  width: 1.875rem;
  height: 1.875rem;
  padding: 0;
}

.cart-result__close-cart > svg {
  width: 1.875rem;
  height: 1.875rem;
}

.cart-result__summary-action {
  margin-top: auto;
  display: block;

  @include media([to-medium, landscape]) {
    display: none;
  }
}

.cart-result__article-search-cart-products-container .cart-result__summary-action {
  display: none;

  @include media([to-medium, landscape]) {
    display: block;
  }
}

.cart-result__summary {
  position: relative;
  margin-bottom: measure(quarter);
  padding: measure(quarter) measure(quarter) 0 measure(quarter);
}

.cart-result__summary--shadow::after {
  content: '';
  position: absolute;

  @include media(to-medium) {
    top: -.75rem;
    right: -#{measure(quarter)};
    left: -#{measure(quarter)};
    height: .75rem;
  }

  top: -.5rem;
  right: measure(quarter);
  left: measure(quarter);
  height: .5rem;
  background-image: linear-gradient(to top, rgba(117, 117, 117, 0.2) 5%, rgba(265, 265, 265, 0));
}

.cart-result__summary > * {
  padding: measure(quarter);
}

.cart-result__summary-item {
  @include body-smaller;
  display: flex;
}

.cart-result__summary-item-value {
  margin-left: auto;
}

.cart-result__summary-item--total {
  @include body-semi-bold;
}

.cart-result__summary-item-value--total-cost {
  margin-left: auto;
}

.cart-result__summary-item-double-row {
  display: flex;
  align-items: center;
}

.cart-result__summary-item-what-vat {
  @include caption;
  margin-left: measure(eighth);
}

/* cart products */

.cart-result__article-search-cart-products-container {
  flex-shrink: 1;
  padding: 0 measure(quarter);
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  @include media([to-medium, landscape]) {
    margin-bottom: measure(quarter);
  }
}

.cart-products {
  @include body-smaller;
  flex-shrink: 1;
  background-color: color(background-white);
}

.cart-products__items>:not(:last-child) {
  margin-bottom: measure(quarter);
}

.cart-result--is-docked .cart-products {
  @include media(medium) {
    max-height: inherit;
  }
}

.cart-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: measure(double);
  color: color(text-gray-light);
}

.cart-empty-state__header {
  @include body-semi-bold;
}

.cart-empty-state__text {
  @include body-smaller;
  width: 100%;
  margin-bottom: 0;
  text-align: center;
}

.cart-result__article-actions-container {
  position: relative;
  display: flex;
  margin-bottom: measure(quarter);
  padding-bottom: measure(quarter);
  background-color: color(background-white);
  z-index: 1;

  @include media(medium) {
    position: sticky;
    top: 0;
  }
}

.cart-result__article-actions-container--shadow {
  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: -.5rem;
    left: 0;
    height: .5rem;
    background-image: linear-gradient(to bottom, rgba(117, 117, 117, 0.2) 5%, transparent)
  }
}

.cart-result__article-actions-container--compact-mode {
  padding-top: measure(quarter);
}

.cart-result__article-actions-container > *:not(:first-child) {
  margin-left: measure(quarter);
}

.cart-result__search-amount {
  width: 9rem;
}

.cart-result__search-action {
  @include reset-button;
  width: 1.25rem;
  height: 1.25rem;
}

.cart-result__search-svg {
  width: 1.25rem;
  height: 1.25rem;
}

.cart-result__to-cart-url {
  margin: measure(quarter);
  margin-top: 0;
}

.cart-result__article-search-cart-products-container .cart-result__summary-action > * {
  @include media([to-medium, landscape]) {
    padding-right: 0;
    padding-left: 0;
    margin-right: 0;
    margin-left: 0;
  }
}

.cart-shell-container__superuser-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
}

.cart-shell-container__dropdown {
  flex: 1;
  margin-right: measure(quarter);
}

</style>
